import { render, staticRenderFns } from "./EventsGridPage.vue?vue&type=template&id=65d308ae&scoped=true"
import script from "./EventsGridPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsGridPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventsGridPage.vue?vue&type=style&index=0&id=65d308ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d308ae",
  null
  
)

export default component.exports